export const PENETRATION = "penetration"
